const FILTER_BAR_DROPDOWN_TYPES = {
  PER_ACCOUNT: 'per_account',
  STATUS: 'status',
  DEADLINE: 'deadline'
};

export default FILTER_BAR_DROPDOWN_TYPES;
